import { useSelector } from 'react-redux';
import type { Property } from 'shared-types/Property';

import { entitySelectors } from '@store/entity/selectors';

import { usePaymentProvider } from './usePaymentProvider';

export const useSinglePageCheckoutSupported = (): boolean => {
  const property = useSelector(entitySelectors.getProperty) as Property | undefined;
  const { isDatatrans } = usePaymentProvider(property);

  return !isDatatrans;
};
